const buildDocumentSharePageV2Url = (uuid = '') => {
  const trimmedUuid = uuid.trim();
  if (!trimmedUuid) return '';
  return `${import.meta.env.VITE_APP_APPURL}/share-document-v2/${encodeURIComponent(trimmedUuid)}`;
};

export { buildDocumentSharePageV2Url };
